import withSuspense from "../../../../hocs/withSuspense";
import { EditNamePageProps, EditNamePage } from "./EditNamePage";
import { SettingsPageSkeleton, SettingsError } from "../../components";

export const EditNamePageWithSuspense = withSuspense<EditNamePageProps>(
  EditNamePage,
  {
    FallbackComponent: SettingsError,
    loading: <SettingsPageSkeleton rows={3} testId="edit-name" />,
  }
);
